export type ClockViewType = 'hours' | 'minutes';
export type ClockMode = '12h' | '24h';

export interface IClockNumber {
  display: number;
  translateX: number;
  translateY: number;
  allowed: boolean;
}

export interface ITimeData {
  minutes: number;
  hours: number;
  meridiem: string;
}

export interface IAllowed24HourMap {
  [hour: number]: { [minute: number]: boolean };
}

export interface IAllowed12HourMap {
  am: { [hour: number]: { [minute: number]: boolean } };
  pm: { [hour: number]: { [minute: number]: boolean } };
}

export interface IClockData {
  mode: ClockMode;

  anteMeridiemAbbreviation: string;
  postMeridiemAbbreviation: string;

  color: string;
  minDate: Date | undefined;
  maxDate: Date | undefined;
  allowed12HourMap: IAllowed12HourMap | null;
  allowed24HourMap: IAllowed24HourMap | null;

  isPm: boolean;

  value: Date | undefined | null;
}
